// extracted by mini-css-extract-plugin
module.exports = {"background":"Moderate-background-b8bf42a497fe427be301596e0da9095f","main":"Moderate-main-fa0ba1a124d25ce628b50909bc80d1eb"};